import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class InfoVacationEvent extends UserEvent {
  public static NAME = 'INFO_VACATION';

  constructor(
    public idVacation: string,
    public texte: string,
    public photos: string[],
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(InfoVacationEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: InfoVacationEvent): InfoVacationEvent {
    return new InfoVacationEvent(obj.idVacation, obj.texte, obj.photos, dayjs(obj.instant), obj.coordinates);
  }
}
